import { Component, ElementRef, HostListener, OnInit } from '@angular/core';

import { MainService } from '../main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { SecurityService } from '../security.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'lib-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {

  timer: string = '00:00:00';
  erpUserString: any;
  erpUser: any;
  le_id: any;

  constructor(private elRef: ElementRef,
    private router: Router,
    private mainService: MainService,
    private spinner: NgxSpinnerService,
    public securitySVC:SecurityService
  ) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const goToTopBtn = this.elRef.nativeElement.querySelector('.go-to-top-button');
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      goToTopBtn.style.display = "block";
    } else {
      goToTopBtn.style.display = "none";
    }
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('svm_jwt') && sessionStorage.getItem('erpUser')) {
      this.erpUserString = sessionStorage.getItem('erpUser');
      this.erpUser = this.erpUserString && JSON.parse(this.erpUserString);
      this.le_id = this.erpUser.le_id;
    }
    this.startTimer();
  }

  startTimer() {
    setInterval(() => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();

      const remainingHours = 23 - hours;
      const remainingMinutes = 59 - minutes;
      const remainingSeconds = 59 - seconds;

      const formattedHours = this.padNumber(remainingHours);
      const formattedMinutes = this.padNumber(remainingMinutes);
      const formattedSeconds = this.padNumber(remainingSeconds);

      this.timer = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }, 1000);
  }

  padNumber(num: number) {
    return num.toString().padStart(2, '0');
  }

  scrollToSubscriptionContainer() {
    const subscriptionContainer = this.elRef.nativeElement.querySelector('.subscription-container');
    if (subscriptionContainer) {
      subscriptionContainer.scrollIntoView({ behavior: 'smooth' });
    }
  }

  async handleOrderNowClick() {
    this.spinner.show();
    console.log("inside order now");

    if (sessionStorage.getItem('svm_jwt') && sessionStorage.getItem('erpUser')) {
      console.log("inside order now");
      try {
        console.log("inside order now");
        let objForSubs = { le_id: this.le_id };
        let responseOfIsSubsFor = await this.mainService.isSubscribedfor(objForSubs);
        console.log('Response:', responseOfIsSubsFor);
        if (responseOfIsSubsFor['error'] == false && responseOfIsSubsFor['data'] == null) {
          let responseOfSubs = await this.mainService.addSubscription(objForSubs);
          console.log('Response:', responseOfSubs);
          if (responseOfSubs['error'] == false) {
            let objToInitAcct = {
              "id": {
                "act_id": responseOfSubs['acct'],
                "jwt": { "uid": "aishwar" }
              },
              "operation": "initAccount"
            };
            let responseOfInitAcct = await this.mainService.initAccount(objToInitAcct);
            console.log('Response:', responseOfInitAcct);
            if (responseOfInitAcct['error'] == false) {
              this.spinner.hide();
              await this.securitySVC.getAllAccounts();
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Subscription added successfully'
              });
            
            } else {
              this.spinner.hide();
              await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Some error occured'
              });
            }
          } else {
            this.spinner.hide();
            await Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Some error occured'
            });
          }
        } else {
          this.spinner.hide();
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Account already exists'
          });
        }
        
      } catch (error) {
        console.error('Error:', error);
      }
    } else {
      this.router.navigate(['/login']);
      this.spinner.hide();
    }
  }

  goToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

}